"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Sections = require("sections");
var Snippets = require("snippets");
var Sticky = require("react-stickynode");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.onType = function (searchValue, setSearch) {
            setSearch(searchValue);
            _this.onOpen();
        };
        _this.handleType = function (value, setSearch) {
            _this.setState({ searchValue: value });
            _this.context.update({ searchTerms: value });
            value && value.length && setSearch ? _this.onType(value, setSearch) : null;
        };
        _this.handleSearch = function (setSearch) {
            var searchValue = _this.state.searchValue;
            _this.context.update({ searchTerms: searchValue });
            searchValue && searchValue.length ? _this.onType(searchValue, setSearch) : null;
        };
        _this.toggleCart = function () {
            _this.context.update({
                cartOpen: !_this.context.state.cartOpen
            });
        };
        _this.toggleMobileNav = function () {
            _this.setState({
                menuOpen: !_this.state.menuOpen,
                searchOpen: false
            });
        };
        _this.onOpen = function () {
            _this.setState({
                searchOpen: true,
                menuOpen: false
            });
        };
        _this.onClose = function () {
            _this.setState({ searchOpen: false });
            _this.setState({ searchValue: "" });
            _this.context.update({ searchTerms: "" });
        };
        _this.customerStep = function (step) {
            _this.context.update({
                account: true,
                accountStep: step
            });
        };
        _this.toggleActive = function (handle) {
            var newHandle = _this.state.active === handle ? null : handle;
            _this.setState({
                active: newHandle
            });
        };
        _this.state = {
            activeDropdown: null,
            previousDropdown: null,
            active: null,
            isFixed: false,
            menuOpen: false,
            searchOpen: false,
            searchValue: "",
            mainMenu: _this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(_this.props.section.settings.main_menu)],
            mobileMenu: _this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(_this.props.section.settings.mobile_menu)],
            teamMenu: _this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(_this.props.section.settings.team_menu)],
            teamLogo: _this.props.data.shop.metafields.teamlogo,
            isMobile: true
        };
        _this.handleHover = _this.handleHover.bind(_this);
        _this.toggleCart = _this.toggleCart.bind(_this);
        return _this;
    }
    Header.prototype.componentDidUpdate = function () {
        this.state.menuOpen ||
            this.state.searchOpen ||
            this.context.state.cartOpen ||
            this.context.state.account ||
            this.context.state.sizingOpen ||
            this.state.active ||
            this.context.state.clickAndCollectOpen
            ? document.body.classList.add("overflow-hidden")
            : document.body.classList.remove("overflow-hidden");
    };
    Header.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', function (e) {
            _this.handleResize(e, _this);
        });
    };
    Header.prototype.handleResize = function (e, ref) {
        var width = window.innerWidth;
        if (width <= 991) {
            ref.setState({
                isMobile: true
            });
        }
        else {
            ref.setState({
                isMobile: false
            });
        }
    };
    Header.prototype.scrollToTop = function () {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    Header.prototype.handleSticky = function (callback) {
        this.setState({
            isFixed: callback.status
        });
    };
    Header.prototype.handleHover = function (status, id) {
        var _this = this;
        status
            ? this.setState({
                activeDropdown: id
            })
            : (this.setState({
                activeDropdown: null,
                previousDropdown: id
            }),
                setTimeout(function () {
                    return _this.state.previousDropdown == id
                        ? _this.setState({
                            previousDropdown: null
                        })
                        : null;
                }, 500));
    };
    Header.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, section = _a.section;
        var searchConfig = data && data.shop && data.shop.metafields && data.shop.metafields["reactify-search"] && data.shop.metafields["reactify-search"].config
            ? data.shop.metafields["reactify-search"].config
            : null;
        return data.template && (data.template.name == "blog" || data.template.name == "article") && data.blog ? (React.createElement(React.Fragment, null,
            React.createElement("header", { className: "relative z-20 flex flex-col-reverse" },
                React.createElement(Sticky, { innerZ: 20, onStateChange: function (status) { return _this.handleSticky(status); } },
                    React.createElement("div", { className: "relative z-50 border-b bg-arctic text-midnight border-charcoal-light" },
                        React.createElement(Snippets.Container, { className: "flex items-center justify-between overflow-hidden py-0-6 mlg:px-11 md:px-3", tag: "section" },
                            React.createElement("div", { className: "relative flex flex-col items-start justify-center w-1/4" },
                                React.createElement("a", { href: "/", className: (data.article ? "absolute pin-y pin-l " : "") + "flex items-center justify-start text-midnight hover:text-charcoal transition-fast " + (this.state.isFixed && data.article ? "opacity-0 invisible translate-y:-20x" : "opacity-100 visible translate-y:0") },
                                    React.createElement(Snippets.Svg, { name: "arrow-left", width: 24, className: "hidden md:block mr-0-4" }),
                                    React.createElement(Snippets.Heading, { size: "h5", tag: "p", className: "hidden font-medium leading-none tracking-wide uppercase md:block" }, "Shop The AFL Store"),
                                    React.createElement(Snippets.Heading, { size: "h5", tag: "p", className: "block font-medium leading-none tracking-wider uppercase md:hidden" }, "Shop")),
                                data.article ? (React.createElement("a", { href: data.blog.url, className: "block text-midnight hover:text-charcoal transition-fast " + (this.state.isFixed ? "opacity-100 visible translate-y:0" : "opacity-0 invisible translate-y:20x") },
                                    React.createElement(Snippets.Heading, { size: "h4", tag: "p", className: "hidden font-mono font-medium leading-none tracking-wide uppercase md:block text-xmd" }, data.blog.title),
                                    React.createElement(Snippets.Heading, { size: "h4", tag: "p", className: "block font-mono font-medium leading-none tracking-wide uppercase md:hidden text-xmd" }, data.blog.title.split("")[0]))) : null),
                            React.createElement("div", { className: "relative flex flex-col items-center justify-center w-1/2 text-center" },
                                React.createElement("div", { className: "absolute pin hidden md:flex items-center justify-center transition-fast " + (this.state.isFixed && data.article ? "opacity-0 invisible translate-y:-20x" : "opacity-100 visible translate-y:0") },
                                    React.createElement(Snippets.Heading, { size: "p", tag: "h2", className: "font-mono italic leading-none tracking-wide" }, "Your Guide To Life, Style & Manly Arts")),
                                data.article ? (React.createElement(React.Fragment, null,
                                    React.createElement("a", { href: data.blog.url, className: "absolute pin w-full flex items-center justify-center md:hidden text-midnight hover:text-charcoal transition-fast " + (!this.state.isFixed ? "opacity-100 visible translate-y:0" : "opacity-0 invisible translate-y:-20x") },
                                        React.createElement(Snippets.Heading, { size: "h2", tag: "h1", className: "block font-mono leading-none tracking-wide uppercase" }, data.blog.title)),
                                    React.createElement("button", { onClick: function () { return _this.scrollToTop(); }, className: "w-full p-0 min-h-3 block text-midnight hover:text-charcoal transition-fast cursor-pointer focus:outline-none " + (this.state.isFixed ? "opacity-100 visible translate-y:0" : "opacity-0 invisible translate-y:20x") },
                                        React.createElement(Snippets.Heading, { size: "p", tag: "p", className: "block font-mono italic leading-none tracking-wide" }, data.article.title)))) : (React.createElement("button", { onClick: function () { return _this.scrollToTop(); }, className: "block cursor-pointer md:hidden text-midnight hover:text-charcoal transition-fast focus:outline-none" },
                                    React.createElement(Snippets.Heading, { size: "h2", tag: "h1", className: "font-mono leading-none tracking-wide uppercase" }, data.blog.title)))),
                            React.createElement("nav", { className: "flex items-center justify-end block w-1/4" },
                                React.createElement(Snippets.Cart, __assign({}, this.props, { toggleCart: this.toggleCart }))))))),
            React.createElement(Snippets.CartDrawer, __assign({}, this.props)))) : (React.createElement("div", null,
            React.createElement("header", { className: "relative z-20 flex flex-col" },
                React.createElement(Sections.Announcement, __assign({}, this.props, { section: data.section.announcement })),
                React.createElement(Sticky, { innerZ: 20, onStateChange: function (status) { return _this.handleSticky(status); } },
                    React.createElement("div", { className: "relative z-50 bg-arctic text-midnight" },
                        React.createElement("div", { className: "bg-navy" },
                            React.createElement(Snippets.Container, { className: "flex items-center justify-between px-0 text-midnight lg:items-end md:py-0 mlg:px-11 md:px-2-4", tag: "section" },
                                React.createElement("div", { className: "flex w-full" },
                                    React.createElement("div", { className: "flex md:flex-grow items-center text-arctic " + (this.state.isFixed > 0 ? "lg:invisible lg:max-w-0 lg:max-h-0 md:visible md:max-w-none md:max-h-none" : "") },
                                        section.settings.headerText ? (React.createElement("p", { className: "hidden italic font-bold leading-tight font-body text-xsmd lg:block" }, section.settings.headerText)) : null,
                                        React.createElement("div", { className: "block h-full lg:hidden text-arctic" },
                                            React.createElement(Snippets.MobileMenu, __assign({}, this.props, { toggleMobileNav: this.toggleMobileNav, visible: this.state.menuOpen })))),
                                    React.createElement("div", { className: "flex justify-center flex-grow py-1 md:py-1 md:py-1-6" },
                                        React.createElement(Snippets.Logo, { settings: data.settings, alt: data.shop.name, className: "flex justify-center flex-grow text-left lg:max-w-26 max-w-19" }),
                                        React.createElement("div", { className: "lg:flex items-center text-arctic hidden " + (this.state.isFixed > 0 ? "visible pl-4 w-full" : "invisible w-0") },
                                            React.createElement("a", { href: "#", className: "text-base font-semibold mr-3-2" }, "Shop By Team"),
                                            React.createElement("a", { href: "#", className: "text-base font-semibold" }, "Shop By Range"))),
                                    React.createElement("div", { className: "items-center justify-end flex-grow hidden md:flex text-arctic lg:pr-0 pr-1-6" },
                                        React.createElement(Snippets.SearchForm, __assign({}, this.props, { onClose: this.onClose, onType: this.handleType, onTrigger: this.handleSearch, searchOpen: this.state.searchOpen, searchValue: this.state.searchValue, searchConfig: searchConfig }))),
                                    React.createElement("div", { className: "flex items-center justify-end text-arctic lg:pr-0 pr-1-6" },
                                        React.createElement(Snippets.Cart, __assign({}, this.props, { toggleCart: this.toggleCart }))))))),
                    this.state.isMobile ?
                        React.createElement(Snippets.MobileNavigation, __assign({}, this.props, { id: "mobile", linklist: this.state.mobileMenu, customerStep: this.customerStep, visible: this.state.menuOpen, searchValue: this.state.searchValue, onClose: this.onClose, onType: this.handleType })) :
                        null),
                React.createElement("div", { className: "relative border-b lg:hidden border-blue-grey" },
                    React.createElement("div", { className: "flex " + this.state.active },
                        React.createElement(Snippets.SearchTrigger, __assign({}, this.props, { searchOpen: this.state.searchOpen, onOpen: this.onOpen })),
                        React.createElement("a", { className: "flex items-center flex-grow w-1/2 text-sm font-medium border-l cursor-pointer py-1-4 text-navy-dark border-blue-grey pl-2-4", onClick: function () { return _this.toggleActive("openTeam"); } },
                            React.createElement("div", { className: "flex items-center" },
                                React.createElement(Snippets.Svg, { name: "small-logo", width: 24, className: "block mr-0-8" }),
                                "Shop by Team",
                                React.createElement(Snippets.Svg, { name: "chevron-down", width: 10, className: "block ml-0-8" })))),
                    React.createElement("div", { className: "md:hidden bg-arctic absolute pin h-4-5 transition-slow block " + (this.state.searchOpen ? "translate-x:0 " : "translate-x:-100") },
                        React.createElement(Snippets.SearchForm, __assign({}, this.props, { onClose: this.onClose, onType: this.handleType, onTrigger: this.handleSearch, searchOpen: this.state.searchOpen, searchValue: this.state.searchValue, className: "", searchConfig: searchConfig })))),
                React.createElement("div", null,
                    React.createElement("div", { className: "relative bg-arctic " + this.state.activeDropdown }, section.settings.main_menu && next_components_1.ShopifyNext.Utils.getMenu(section.settings.main_menu) ? (React.createElement(Snippets.Navigation, { id: "main", activeDropdown: this.state.activeDropdown, previousDropdown: this.state.previousDropdown, className: "items-center justify-center hidden w-full lg:flex bg-arctic", handleHover: this.handleHover, linklist: this.state.mainMenu })) : null),
                    React.createElement("div", { className: "hidden border-t border-blue-grey-70 lg:block" }),
                    React.createElement("div", { className: "bg-arctic" },
                        React.createElement(Snippets.Container, { className: "fixed flex flex-wrap items-center justify-between text-midnight lg:items-end mlg:px-11 md:px-2-4 md:static ", tag: "section" }, section.settings.team_menu && next_components_1.ShopifyNext.Utils.getMenu(section.settings.team_menu) ? (React.createElement(Snippets.TeamNavigation, { id: "team", className: "bg-arctic w-full lg:flex overflow-auto lg:overflow-hidden \n                    lg:items-center lg:pb-0 lg:max-h-none justify-center transition-fast " + (this.state.active ? " max-h-full-h" : " max-h-0"), linklist: this.state.teamMenu, previousDropdown: this.state.previousDropdown, activeDropdown: this.state.activeDropdown, handleHover: this.handleHover, displayTeamMenu: true })) : null)),
                    React.createElement("div", { className: "hidden border-t border-blue-grey-70 lg:block" }))),
            this.props.data.section.popups ? React.createElement(Sections.Popups, __assign({}, this.props, { section: this.props.data.section.popups })) : null,
            React.createElement(Snippets.CartDrawer, __assign({}, this.props))));
    };
    Header.contextType = next_components_1.ShopifyNext.Context;
    Header.sectionId = "header";
    Header.typingTimer = null;
    return Header;
}(React.PureComponent));
exports.Header = Header;
